export default "__VITE_ASSET__DIPksvvs__"